const HIDE_ON_PAGES = ['/datenschutz', '/impressum']

const isLegalPage = () => {
    return HIDE_ON_PAGES.includes(typeof window !== 'undefined' ? window.location.pathname : '')
}

export default isLegalPage